import { render, staticRenderFns } from "./ProfileFamilies.vue?vue&type=template&id=7dc07355&scoped=true&"
import script from "./ProfileFamilies.vue?vue&type=script&lang=js&"
export * from "./ProfileFamilies.vue?vue&type=script&lang=js&"
import style0 from "./ProfileFamilies.vue?vue&type=style&index=0&id=7dc07355&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc07355",
  null
  
)

export default component.exports